import React from 'react';

import { RatchetModel } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import downloadLargeTokens from '@amzn/meridian-tokens/base/icon/download-large';
import Box from '@amzn/meridian/box';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';

import { FilterInput } from 'src/components/FilterInput';
import { useExportCoreRates } from 'src/hooks/useExportCoreRates';
import { IPrimeAMFRateCardGridRowData } from 'src/types/IRateCard';

import { ViewCppGrid } from './ViewCppGrid';
import { ViewMauGrid } from './ViewMauGrid';

interface IViewRateCardsProps {
    rateCardRowData: IPrimeAMFRateCardGridRowData;
    primeConversion?: RatchetModel;
    primeTertiaryConversion?: RatchetModel;
    amfConversion?: RatchetModel;
    dataLoaded?: boolean;
}

export const ViewCoreRates = ({
    rateCardRowData,
    primeConversion,
    amfConversion,
    primeTertiaryConversion,
    dataLoaded = true
}: IViewRateCardsProps) => {
    const { filterText, setFilterText, setCppGridApi, setMauGridApi, exportCoreRates } = useExportCoreRates();
    const conversion = primeConversion ?? amfConversion;
    const hasMau = rateCardRowData.mau.length > 0;

    return (
        <Column height={'100%'} heights={['fit', 'fill', 'fill']}>
            <Box type="fill" spacingInset="400">
                <Row alignmentHorizontal="justify">
                    <FilterInput filterText={filterText} setFilterText={setFilterText} />
                    <Button type="link" size="small" onClick={exportCoreRates}>
                        <Icon tokens={downloadLargeTokens} />
                        Download
                    </Button>
                </Row>
            </Box>
            <ViewCppGrid
                cppRowData={rateCardRowData.cpp}
                conversion={conversion}
                tertiaryConversion={primeTertiaryConversion}
                filterText={filterText}
                setCppGridApi={setCppGridApi}
                dataLoaded={dataLoaded}
            />
            {rateCardRowData.mau.length > 0 && (
                <ViewMauGrid
                    mauRowData={rateCardRowData.mau}
                    filterText={filterText}
                    setMauGridApi={setMauGridApi}
                    dataLoaded={dataLoaded}
                />
            )}
        </Column>
    );
};
